interface LoadingProps {
  text?: string;
}

export function Loading({ text = '載入中...' }: LoadingProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="w-8 h-8 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
      <p className="mt-4 text-gray-500">{text}</p>
    </div>
  );
}
